import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'

export const CustForm = () => {
  
  return (
    <EntityForm />
  )
}